import './ProgramGuide.scss'
import { useEffect, useRef, useState } from "react";
import { formatDate } from "../../../../Util/format_date";
import { get_day_epg, get_tariff } from "../../../../../server/requests";

import InfoField from "../InfoField/InfoField";
import MiniCardChannel from "../MiniCardChannel";

import icon_back from "../../../../SubUsers/images/back-button.png";
import play_icon from '../../images/play.png'
import { useRouter } from "../../../../../hooks/router";
import Loading from '../../../../Loading/Loading';


export default function ProgramGuide({
    epg,
    btn_show_info,
    channel,
    popUpType,
    btn_fields_live,
    channelList,
    callBackArchiveEpg
}) {
    const router = useRouter()

    const refParEpg = useRef()
    const refElem = useRef()

    const [sevenDays, setSevenDays] = useState([])

    const [activeDay, setActiveDay] = useState(0)
    const [activeChannel, setActiveChannel] = useState(0)
    const [epgListProgramGuide, setEpgListProgramGuide] = useState([])
    const [showLoading, setShowLoading] = useState(false)
    const [epgProgram, setEpgProgram] = useState(null)
    const [activeEpgIndex, setActiveEpgIndex] = useState('')
    const [active_channel, setActive_channel] = useState('')
    const [hasArchive, setHasArchive] = useState(false)

    useEffect(() => {

        let seven_days = []

        for (var i = -3; i <= 3; i++) {

            var date = new Date()
            seven_days.push(date.setDate(date.getDate() + i))

        }

        req_get_tariff()
        // day.innerHTML = formatDate(new Date(seven_days[i]), 'd')
        // week.innerHTML = formatDate(new Date(seven_days[i]), 'EEE').toUpperCase()
        setSevenDays([...seven_days])

    }, [])

    useEffect(() => {
        if (epg) {
            setEpgProgram(epg)
        }
    }, [epg])

    useEffect(() => {
        setShowLoading(true)
        const body = {
            date: activeDay,
            id: channelList[activeChannel].id_epg
        }
        get_day_epg(body, data => {
            setEpgListProgramGuide([...data])
            setShowLoading(false)
            setActiveEpgIndex(null)
            scrollIntoActiveEpg()
        })
    }, [activeChannel, activeDay])

    const scrollIntoActiveEpg = () => {

        let elem = document.getElementById('refElem')
        let first_elem = document.querySelector('.card_epg_program_guide')
        // if (elem) elem.scrollIntoView({ behavior: "smooth" })
        
        if (elem) {

            let offsetTop = elem.offsetTop - 230

            document.querySelector('.epg_list_program_guide').scrollTo({
                top: offsetTop,
                left: 0,
                behavior: "smooth",
            })

        } else if (first_elem) {

            first_elem.scrollIntoView({ behavior: "smooth" })

        }

    }

    const btn_get_day_epg = (index) => {
        setActiveDay(index)
    }

    const btn_channel_program_guide = (elem, index) => {
        setActive_channel(elem)
        setActiveChannel(index)
    }

    const _set_play_btn = (e, i) => {
        setEpgProgram(e)
        setActiveEpgIndex(i)
    }
    const _btn_play_archive = (e) => {
        callBackArchiveEpg(e, active_channel ? active_channel : channel)
    }

    const double_click_channel = (e) => {
        router.push(`/player?type=live&id=${e.id}`)
    }
    function req_get_tariff() {
        get_tariff({}, data => {

            if (data.service && data.service.length) {

                const archive = data.service.find(item => item.serviceId == 3)

                if (archive) setHasArchive(true)
                else setHasArchive(false)

            }
        }, err => {
            console.log(err)
        })
    }

    return (
        <div className="live_player_fields">
            <div className="main_program_guide">
                <div id="btn_back_main_program">
                    <div className="btn_back_main_program">
                        <img src={icon_back} alt="" onClick={btn_fields_live} />
                    </div>
                    <div className="date_in_program_guide">
                        <h1>{formatDate(new Date(), 'bbbb MMMM d,yyyy HH:mm')}</h1>
                    </div>
                </div>
                <div className="info_field_program_guide">
                    <InfoField
                        epg={epgProgram ? epgProgram : null}
                        btn_show_info={btn_show_info}
                        popUpType={popUpType}
                        channel={channel}
                        active_channel={active_channel}
                    />
                </div>
                <div className="main_epg_and_channels">
                    <div className="channels_program_guide">
                        <h2>CHANNELS</h2>
                        <div className="list_channels_program_guide">
                            {channelList.map((e, i) => {
                                return <MiniCardChannel
                                    key={i}
                                    doubleClickChannel={double_click_channel}
                                    btn_channel_live_fields={btn_channel_program_guide}
                                    activeChannel={activeChannel}
                                    channel={channel}
                                    active_channel={active_channel}
                                    elem={e}
                                    index={i}
                                />
                            })}
                        </div>
                    </div>
                    <div className="days_and_epg">
                        <h2>PROGRAM GUIDE</h2>
                        <div className="main_days_and_epg">
                            <div className="days_program_guide" ref={refParEpg}>
                                {sevenDays.map((e, i) => {
                                    return (
                                        <div
                                            key={i}
                                            className="day_program_guide"
                                            style={activeDay + 3 === i ? { borderColor: 'white' } : null}
                                            onClick={() => btn_get_day_epg(i - 3)}
                                        >
                                            <h3>{formatDate(new Date(e), 'd')}</h3>
                                            <h5>{formatDate(new Date(e), 'EEE').toUpperCase()}</h5>
                                        </div>
                                    )
                                })}
                            </div>

                            {showLoading ?
                                <div className="loading_program_guid">
                                    <Loading />
                                </div> :
                                epgListProgramGuide.length ?
                                    <div className="epg_list_program_guide">
                                        {epgListProgramGuide.map((e, i) => {
                                            let time = new Date().getTime() / 1000
                                            return (
                                                <div
                                                    key={i}
                                                    className="card_epg_program_guide"
                                                    id={time > e.start_ut && time < e.stop_ut ? 'refElem' : ''}
                                                    onClick={hasArchive ? (() => _set_play_btn(e, i)) : null}
                                                >
                                                    <p className="time_epg_card">{formatDate(new Date(e.start_ut * 1000), 'HH:mm')}</p>
                                                    <div className="active_epg_circle"
                                                        style={{
                                                            backgroundColor: time > e.start_ut && time < e.stop_ut ? "#1DAE00" :
                                                                time < e.start_ut ? "#BAB4BF" : "red"
                                                        }}
                                                    ></div>
                                                    <p className="title_epg_card">{e.title}</p>
                                                    {activeEpgIndex == i && time > e.start_ut ?
                                                        <div className={'play_archive_program_guide'}
                                                            onClick={() => _btn_play_archive(e)}>
                                                            <img src={play_icon} alt="" />
                                                        </div>
                                                        : null}
                                                </div>
                                            )
                                        })}
                                    </div> :
                                    <div className="when_no_epg">
                                        <h1>No Program Guide Found</h1>
                                    </div>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}